import {
  MockHook,
  useAvailableApps,
  useDefaultAppSetting,
} from '@jupiterone/jupiter-web-toolkit';

const useUserDefaultAppSelectorLogic = () => {
  const apps = useAvailableApps();
  const [defaultApp, setDefaultApp] = useDefaultAppSetting();

  const handleDefaultAppChange = async (
    event: React.ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const newAppUrl = event.target.value;
    const app = apps.find(({ url }) => url === newAppUrl);
    if (app) await setDefaultApp(app.url);
  };

  return {
    apps,
    defaultApp,
    handleDefaultAppChange,
  };
};

export type UserDefaultAppSelectorComponentProps = ReturnType<
  typeof useUserDefaultAppSelectorLogic
>;
export const MOCK_USER_DEFAULT_APP_SELECTOR_PROPS: UserDefaultAppSelectorComponentProps = {
  apps: [
    {
      name: 'test app 1',
      icon: MockHook.mockFunction,
      url: 'url',
      featureEntitlementName: 'test' as any,
    },
  ],
  defaultApp: 'url',
  handleDefaultAppChange: MockHook.mockFunction,
};
export default MockHook.useMockHook(
  useUserDefaultAppSelectorLogic,
  MOCK_USER_DEFAULT_APP_SELECTOR_PROPS
);
